import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { clearInvalidSession } from "helpers/authSession";
import useAppNavigationGuards from "hooks/useAppNavigationGuards";
import useUnauthorizedSessionHandler from "hooks/useUnauthorizedSessionHandler";

const AppShell = () => {
  useAppNavigationGuards();
  useUnauthorizedSessionHandler();

  useEffect(() => {
    clearInvalidSession();
  }, []);

  return <Outlet />;
};

export default AppShell;
